<template>
	<div>
		<div class="row">
			<b-tabs pills v-model="tabIndex">
				<b-tab v-for="(i,idx) in tabList" :key="idx" :title="i.name">
				</b-tab>
				<template #tabs-end>
				<b-nav-item class="filter" role="presentation" 
					@click.prevent="searchFilterButtonClick" href="#"><i class="fas fa-angle-down icon-down"></i><i class="fas fa-angle-up icon-up"></i></b-nav-item>
				</template>
			</b-tabs>

		</div>
		<div class="row">
			<div class="col-md-12 search form minimize"> 						
				<form class="search bright" :class="'formsearch' + idx" v-on:change="resumePilihan">
					<div class="button_attach_detach" style="float:right;">
						<b-button @click="floatingSearchForm" class="attach detach" variant="light" href="#"><i class="fas fa-angle-right"></i></b-button>
					</div>
					<div class="row">
						<div class="col-md-6 form-group">
							<ReportParamDateRange title="Date" v-model="date" />
						</div>
						<div class="col-md-3 form-group">
							<ReportParamSelect title="Status" name="status" v-model="status" :options="options.status" />
						</div>
						<div class="col-md-3 form-group">
							<ReportParamSelect title="Rekap" name="rekap" v-model="rekap" :options="options.rekap" />
						</div>
					</div>
				</form>
			</div> 
			
		</div> 
		
		<div class="row">
			<div class="col-md-12 mx-auto">
				<div class="h-100 d-flex align-items-center justify-content-center">
					<ReportResultTable reportname="CustomerComplaint" :reportdata="reportdata" :reporturl="urlRequestParams"/>
					<Loader :loading="this.loading.table" :customclass="''" class="child"/>
				</div>
			</div>
		</div>
    </div>
</template>

<script>

import Customer from '@/components/page/Customer.js'
import ReportParamDateRange from '@/views/pages/ReportParamDateRange.vue'
import ReportParamSelect from '@/views/pages/ReportParamSelect.vue'
import ReportResultTable from '@/views/pages/ReportResultTable.vue'
import {Config, Penanggalan, AxiosWithJar } from '@/utility.js'
import Loader from '@/components/loader/Loader.vue'


export default
{
	extends:Customer,
	components: {
		ReportParamDateRange,
		ReportParamSelect,
		ReportResultTable,
		Loader,
	},
	computed:{
	},
    data() {
      return {
			date: { 
				Start: this.$route.query.dateStart ? this.$route.query.dateStart : Penanggalan().tahunSekarang,
				End: this.$route.query.dateEnd ? this.$route.query.dateEnd : Penanggalan().sekarang, 
			},
			urlRequestParams: '',
			options: {
				status:[
					{ value: "", name: "ALL" }, 
					{ value: "On Progress", name: "ON PROGRESS" }, 
					{ value: "Close", name: "CLOSE" },
				],
				rekap:[
					{ value: "", name: "ALL" }, 
					{ value: "status", name: "BY STATUS" }, 
				],
			},
        tabList:[
			{name:'135'},
			{name:'SPBU'},
		],
        tabIndex:this.$route.query.tab, 
		reportdata:[],
		status : this.$route.query.status ? this.$route.query.status : '',
		rekap : this.$route.query.rekap ? this.$route.query.rekap : '',
      }
    },

	watch:
	{
		tabIndex() { this.resumePilihan() },
		date(){ this.resumePilihan() },
	},      
	mounted(){
        Array.from(document.querySelectorAll('aside li.nav-item a')).map((e)=>{e.classList.remove('active')})
        document.querySelector('li.nav-item a.'+window.location.pathname.split('/')[1]).classList.add('active')
        this.$emit('childrenRoute')		
        //this.searchFilterButtonClick()
		this.resumePilihan()


    },
    methods:{
        floatingSearchForm(){
            document.querySelector('.search.form').classList.toggle('floating')            
        },
        resumePilihan(){
            this.urlRequestParams=Config().apiURL
			if (this.tabIndex == 0) this.urlRequestParams+='/customer/complaint135?'
			else if (this.tabIndex == 1) this.urlRequestParams+='/customer/complaintspbu?'
            this.urlRequestParams+='&date-range-start='+this.date.Start
            this.urlRequestParams+='&date-range-end='+this.date.End
            this.urlRequestParams+='&status='+this.status
            this.urlRequestParams+='&rekap='+this.rekap

			this.loading.table = true;
            AxiosWithJar().get(this.urlRequestParams)
            .then((response)=>{ 
                this.reportdata = response.data;

            })
			.catch(error => {
				console.log(error)
				//this.errored = true
				//error.response.data
			})
			.finally(() => {
				this.loading.table = false;
			})

            

        },

        searchFilterButtonClick(){
            document.querySelector('li.filter').classList.toggle('down')
            var select=document.querySelectorAll('.search.form')
            Array.from(select).map((e)=>{e.classList.toggle('minimize')})            
        }
    }
}
</script>
<style>
    .tabs .card-header{ padding-bottom:0px ;}
    .nav.nav-pills { background: rgba(20,109,182,.75) !important; border-radius: 10px 10px 0px 0px !important; padding: 0px !important; margin-top: 10px; }
    .nav.nav-pills .nav-link { color: #f8f9fa !important; border-radius: 5px 0px 0px 0px !important; background-color: none !important; margin-right: 10px !important; font-weight: 500; padding: 15px 20px; font-size: 0.875rem; }
    .nav.nav-pills .nav-link.active{ font-weight: bold; color: #f8f9fa  !important; background-color: transparent  !important;}
    .tab-pane.active { transition: all 0.5s ease-in-out; }
    .tab-pane.card-body { flex: 1 1 auto; padding: 0px 8px;  transition: all 0.5s ease-in-out;}
    .nav.nav-pills li.filter .nav-link{ position: absolute; right:0px; bottom: 0px; top: 0px; display: flex;
    align-items: center; }
    

    .table .card .card-header{ display:none;}
    .table .card .card-body{ padding: 0px;}
    .table.pdf{ border:0px; }
    .table.pdf tr,.table.pdf td,.table.pdf th{ border:0px; }
    .table.pdf tbody tr:nth-child(2n+2){ background:#f1f1f1; }
    
    .table.pdf thead tr{ background: #ccc; color:#333;}
 

    .filter .icon-up { display: flex; }
    .filter.down .icon-up { display: none; }
    .filter .icon-down { display: none; }
    .filter.down .icon-down { display: flex; }
 

</style>